import * as React from 'react';

import classNames from 'classnames';

import {PaperPlane} from '../icon';
import {Stack} from '../layout/stack/stack';
import {Body} from '../typography/body';

import styles from './chat-preview.module.css';

type Props = {
    showPoweredBy: boolean | null | undefined;
    shouldHideInputField?: boolean;
    showSubmitButton?: boolean;
    submitButtonText?: string;
};

export const ChatFooter = (props: Props) => {
    return (
        <div className={classNames(styles['footer-wrapper'])}>
            <Stack spacing={8}>
                {props.showSubmitButton && (
                    <div className={classNames(styles['footer-submit-button'])}>
                        {props.submitButtonText}
                    </div>
                )}
                {!props.shouldHideInputField && (
                    <div
                        className={classNames(styles['footer-input'], {
                            [styles['footer-powered-by']]: props.showPoweredBy,
                        })}
                    >
                        <Body size='small'>Type a message</Body>
                        <PaperPlane size={20} />
                    </div>
                )}
            </Stack>
        </div>
    );
};
